<template>
	<AppFieldNumeric
		:id="context.id"
		v-model="modelValue"
		:precision
		:value-type="valueType"
		:required="Boolean(context.required)"
		:disabled="Boolean(context.disabled)"
		:prefix="type === 'loanlinkCurrency' ? '€' : undefined"
		:suffix="type === 'loanlinkPercentage' ? '%' : undefined"
		:grouping="type === 'loanlinkCurrency'"
	/>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import type { FormKitFrameworkContext } from "@formkit/core";
import { ValueType } from "@/enums/ValueType";

const props = defineProps<{
	context: FormKitFrameworkContext;
}>();

const type = computed(() => props.context.type);
const valueType = computed(() => {
	switch (type.value) {
		case "loanlinkCurrency":
			return ValueType.Currency;
		case "loanlinkPercentage":
			return ValueType.Percentage;
		default:
			return ValueType.Number;
	}
});

const precision = computed(() => {
	switch (type.value) {
		case "loanlinkCurrency":
		case "loanlinkPercentage":
			return 2;
		default:
			return 0;
	}
});

const modelValue = ref<number | undefined>();

const data = computed(() => props.context.value);

watch(
	data,
	(newValue, oldValue) => {
		if (newValue === oldValue) {
			return;
		}

		modelValue.value = newValue;
	},
	{ immediate: true },
);

watch(modelValue, async (newValue, oldValue) => {
	if (newValue === oldValue) {
		return;
	}

	await props.context.node.input(newValue);
});
</script>
